import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

// import moment from 'moment'
// import 'moment/locale/es'

import Pagination from "../../services/Pagination";
import { Table } from 'react-bootstrap'



import ModalEditarCiudadano from './ModalEditarCiudadano'


const CiudadanosGestion = () =>{


  const [allSessionsCount,setCounter] = useState(0);
  const sessionsPerPage = 50
  const [currentPage, setCurrentPage] = useState(1);

  const [ text_busqueda, setTextoBusqueda ] = useState('')

  const [ cargando_, setCargando ] = useState( false )

  const skull = { results: [] }

  const [ resultados, setResultados ] = useState<any>({...skull})

  const cargarMiReporte = async(page:number)=>{
    try{
      setCargando(true)
      let skip = 0
      if(page===0) skip = 0; else skip = (page*sessionsPerPage);
      let response : any = await RequestService.getEndPoint(`clientes/${[true]}/busqueda?where=${text_busqueda}&skip=${skip}&limit=${sessionsPerPage}`)
      setCounter(response.data.totalCount)
      setResultados(response.data.resultados)
      setCargando(false)
    }
    catch(e:any){

      if (e.response?.status) {
        switch (e.response.status) {
          case 404:
            toast.error("Debes escribir algo")
            break;
          default:
            toast.error(e.response?.data)
        }
      }
      else{
        toast.error("Problemas con la busqueda")
      }
      setCargando(false)

    }
  }


  const busqueda = async () =>{
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setCurrentPage(1)
  }

  // const [ arreglo_estatus, setEstatus ] = useState<any>([true])


  // const todos = () =>{
  //   setEstatus([true])
  // }
  // const ninguno = () =>{
  //   setEstatus([false])
  // }


      React.useEffect(() => {
        busqueda()
      }, []);




  const [ ciudadano_seleccionado, setCiudadanoSeleccionado ] = useState<any>(null)
  const [ show_ModalEditarCiudadano, setModalEditarCiudadano ] = useState<boolean>(false)
  const handleShow_ModalEditarCiudadano = (ciudadano:any) => {
    setCiudadanoSeleccionado(ciudadano)
    setModalEditarCiudadano(true)
  }
  const handleClose_ModalEditarCiudadano = () => {
        busqueda()
    setModalEditarCiudadano(false)
  }




      return (
          <>
            <div className="container-fluid">

              <div className="row justify-content-center">
                <div className="col-10 col-sm-11">

                    <h4>Gestión de Cliente</h4>
                    <hr/>
                    






                    
                        <div className="mb-2">
                            <label className="form-label">Búsqueda</label>
                            <div className="hstack gap-3">
                              <input className="form-control me-auto" type="text"  onKeyDown={(e)=>{if(e.keyCode === 13){ busqueda() }}} value={text_busqueda} onChange={event => setTextoBusqueda(event.target.value)} />
                              <button type="button" onClick={busqueda}  className="btn btn-secondary"><i className="fa fa-search" /></button>
                              <div className="vr"></div>
                              <button type="button" onClick={(e:any)=>{setTextoBusqueda('')}} className="btn btn-outline-danger"><i className="fa fa-trash"/></button>
                            </div>
                        </div>
                        




                          {  (!cargando_) && (

                              <>

                                   {
                                     resultados.length > 0 && (

                                       <>


                                       <label className="mt-4 form-label">Resultados</label>


                                        <Table responsive="lg">
                                          <thead>
                                            <tr>
                                              <th scope="col">C.U.R.P.</th>
                                              <th scope="col">R.F.C.</th>
                                              <th scope="col">Cliente</th>
                                              <th scope="col"> </th>
                                              <th scope="col"> </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {


                                              resultados.map( (ciudadano:any,indice_cliente:number) =>
                                                  <tr key={indice_cliente} style={{fontSize:12}}>
                                                    <td className="v text-left" style={{"width":"170px"}}>
                                                            
                                                        <p className="nm">{ciudadano.curp}</p>

                                                    </td>
                                                    <td className="v text-left" style={{"width":"170px"}}>
                                                            
                                                        <p className="nm">{ciudadano.rfc}</p>

                                                    </td>
                                                    <td className="v text-left" >
                                                        <p className="nm"><small><b>{ciudadano.nombres}</b></small></p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"180px"}}>
                                                        <small>{ciudadano.paterno} {ciudadano.materno}</small>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"60px"}}>
                                                        <button type="button" onClick={(e:any)=>{handleShow_ModalEditarCiudadano(ciudadano)}} className="btn btn-sm btn-link"><i className="fa fa-edit"/></button>
                                                    </td>
                                                  </tr>
                                               )
                                            }

                                          </tbody>
                                        </Table>


                                          <Pagination
                                            itemsCount={allSessionsCount}
                                            itemsPerPage={sessionsPerPage}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            cambiarPaginaEvento={cargarMiReporte}
                                            alwaysShown={false}
                                          />


                                        </>



                                       )
                                     
                                   }


                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}





                </div>
              </div>

            </div>





  {
    show_ModalEditarCiudadano && (
      <ModalEditarCiudadano show={show_ModalEditarCiudadano} handleClose={handleClose_ModalEditarCiudadano} ciudadano={ciudadano_seleccionado} />
      )

  }

          </>

      );
  

}

export default CiudadanosGestion
